import { FC } from "react";
import { cn } from "../utils/class-names";

export const ChevronDownIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={cn("w-6 h-6", className)}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9999 14.9502C11.8666 14.9502 11.7416 14.9292 11.6249 14.8872C11.5083 14.8459 11.3999 14.7752 11.2999 14.6752L6.67494 10.0502C6.49161 9.86689 6.40427 9.63755 6.41294 9.36222C6.42094 9.08755 6.51661 8.85855 6.69994 8.67522C6.88327 8.49189 7.11661 8.40022 7.39994 8.40022C7.68327 8.40022 7.91661 8.49189 8.09994 8.67522L11.9999 12.5752L15.9249 8.65022C16.1083 8.46689 16.3376 8.37922 16.6129 8.38722C16.8876 8.39589 17.1166 8.49189 17.2999 8.67522C17.4833 8.85855 17.5749 9.09189 17.5749 9.37522C17.5749 9.65855 17.4833 9.89189 17.2999 10.0752L12.6999 14.6752C12.5999 14.7752 12.4916 14.8459 12.3749 14.8872C12.2583 14.9292 12.1333 14.9502 11.9999 14.9502Z"
      fill="currentColor"
    />
  </svg>
);
